var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c("search-head", { attrs: { showMax: true } }),
      _c(
        "div",
        {
          staticClass: "content clearfix",
          staticStyle: { "padding-top": "16px" },
        },
        [
          _c("div", { staticClass: "contentLeft" }, [
            _c("div", { staticClass: "banner" }, [
              _c(
                "div",
                {
                  staticClass: "cover",
                  on: {
                    click: function ($event) {
                      return _vm.clickMarbItem(
                        "6",
                        "/zxk/junbros/advancedSearch"
                      )
                    },
                  },
                },
                [
                  _c("img", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      src: require("@/assets/newicons/ic01.png"),
                      alt: "",
                    },
                  }),
                ]
              ),
            ]),
            _c("div", { staticClass: "div-search" }, [
              _c("div", { staticClass: "search-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "div-scrollbar",
                    staticStyle: { padding: "0px 0px" },
                  },
                  [
                    _c("el-scrollbar", { staticStyle: { height: "100%" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "24px",
                            "padding-right": "24px",
                          },
                        },
                        [
                          _c("div", { staticClass: "search-title" }, [
                            _vm._v("区域查询"),
                          ]),
                          _vm._l(_vm.fastLabel, function (item, i) {
                            return _c(
                              "span",
                              {
                                key: i,
                                staticClass: "span-tag",
                                on: {
                                  click: function ($event) {
                                    return _vm.chooseCity(item, i)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(item.label))]
                            )
                          }),
                          _c(
                            "ul",
                            { staticStyle: { "margin-top": "17px" } },
                            _vm._l(_vm.areaCode, function (area, i) {
                              return _c("li", { key: i }, [
                                _c(
                                  "b",
                                  {
                                    staticStyle: {
                                      "font-weight": "blod",
                                      color: "#333333",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.chooseCity(area, i)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(area.label))]
                                ),
                                _c(
                                  "span",
                                  _vm._l(
                                    area.childOption,
                                    function (city, index) {
                                      return _c(
                                        "em",
                                        {
                                          key: index,
                                          on: {
                                            click: function ($event) {
                                              return _vm.chooseCity(
                                                area,
                                                i,
                                                city,
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(city.label))]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ])
                            }),
                            0
                          ),
                        ],
                        2
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "search-content ml-20" }, [
                _c(
                  "div",
                  {
                    staticClass: "div-scrollbar",
                    staticStyle: { padding: "0px 0px" },
                  },
                  [
                    _c("el-scrollbar", { staticStyle: { height: "100%" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "24px",
                            "padding-right": "24px",
                          },
                        },
                        [
                          _c("div", { staticClass: "search-title" }, [
                            _vm._v("行业查询"),
                          ]),
                          _c(
                            "ul",
                            _vm._l(_vm.industryInfo, function (item, i) {
                              return _c("li", { key: i }, [
                                _c(
                                  "b",
                                  {
                                    staticStyle: {
                                      width: "120px",
                                      "font-weight": "blod",
                                      color: "#333333",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.chooseIndustry(item, i)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(item.industry))]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      width: "calc(100% - 140px)",
                                    },
                                  },
                                  _vm._l(
                                    item.children,
                                    function (children, index) {
                                      return _c(
                                        "em",
                                        {
                                          key: index,
                                          on: {
                                            click: function ($event) {
                                              return _vm.chooseIndustry(
                                                item,
                                                i,
                                                children,
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(children.industry))]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ])
                            }),
                            0
                          ),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
            ]),
            _c("div", { staticClass: "leftList" }, [
              _c("div", { staticClass: "title" }, [
                _c(
                  "h4",
                  {
                    class: _vm.tabsType === 2 ? "is-tabs" : "",
                    on: {
                      click: function ($event) {
                        return _vm.clickTabsType(2)
                      },
                    },
                  },
                  [_vm._v("最新企业")]
                ),
                _vm.tabsType === 2
                  ? _c(
                      "div",
                      {
                        staticStyle: { "font-size": "13px" },
                        on: {
                          click: function ($event) {
                            return _vm.newCompany(false)
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/newicons/shauxin.png"),
                          },
                        }),
                        _vm._v("换一换"),
                      ]
                    )
                  : _vm._e(),
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.waiting,
                      expression: "waiting",
                    },
                  ],
                  staticClass: "detail",
                  staticStyle: {
                    "min-width": "100%",
                    "margin-left": "-11px",
                    "margin-right": "-11px",
                    display: "inline-block",
                    "grid-template-columns": "none",
                    overflow: "initial",
                    "max-height": "initial",
                  },
                },
                _vm._l(_vm.companyCards, function (companyCard) {
                  return _c(
                    "div",
                    { key: companyCard.id, staticClass: "new-item" },
                    [
                      _c("company-card1", {
                        staticClass: "companyCard",
                        staticStyle: {
                          width: "100%",
                          height: "167px !important",
                          "margin-top": "22px",
                        },
                        attrs: {
                          companyType: 1,
                          baseData: companyCard,
                          xiaoT: true,
                        },
                        on: {
                          "drawer-handle": _vm.showDrawer,
                          "changeNews-handle": _vm.getNews,
                          "change-recommendList": _vm.recommendList,
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
            _vm.hideBind
              ? _c("div", { staticClass: "leftList" }, [
                  _c("div", { staticClass: "title" }, [
                    _c("h4", { staticClass: "is-tabs" }, [_vm._v("企业招标")]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-size": "13px",
                          color: "rgba(80, 136, 255, 1)",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.clickMarbItem(
                              "4",
                              "/zxk/search/biddingInquiry"
                            )
                          },
                        },
                      },
                      [_vm._v("更多")]
                    ),
                  ]),
                  _c("div", { staticStyle: { padding: "16px 0px 0px 0" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "detail",
                        staticStyle: {
                          display: "block",
                          "grid-template-columns": "none",
                          overflow: "initial",
                          "max-height": "initial",
                        },
                      },
                      _vm._l(_vm.tenderList, function (item, i) {
                        return _c(
                          "div",
                          {
                            key: i,
                            staticClass: "cardWrap",
                            staticStyle: {
                              height: "132px",
                              float: "none",
                              padding: "24px 32px",
                              "box-shadow": "none",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "nameWrap mb-10",
                                staticStyle: { height: "22px" },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "name textOverflow",
                                    staticStyle: {
                                      "font-size": "16px",
                                      "line-height": "22px",
                                      color: "#333333",
                                      "font-weight": "bold",
                                    },
                                    attrs: { title: item.title },
                                  },
                                  [_vm._v(_vm._s(item.title))]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "tags mb-10",
                                staticStyle: { display: "inline-block" },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "fl colore6a23c sty001",
                                    style: _vm.getStyle(item.noticeLevel),
                                  },
                                  [_vm._v(_vm._s(item.noticeLevel))]
                                ),
                              ]
                            ),
                            _c("dl", { staticClass: "text" }, [
                              _c(
                                "dd",
                                {
                                  staticClass: "mr-10",
                                  staticStyle: {
                                    "max-width": "100%",
                                    width: "100%",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "sty004" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "textOverflow",
                                        staticStyle: { "margin-right": "32px" },
                                      },
                                      [
                                        _c("span", { staticClass: "sty002" }, [
                                          _vm._v("相关公司："),
                                        ]),
                                        _c("span", {
                                          staticClass: "textOverflow sty003",
                                          attrs: { title: item.companyName },
                                          domProps: {
                                            innerHTML: _vm._s(item.companyName),
                                          },
                                        }),
                                      ]
                                    ),
                                    _c("div", { staticClass: "textOverflow" }, [
                                      _c("span", { staticClass: "sty002" }, [
                                        _vm._v("发布时间："),
                                      ]),
                                      _c("span", { staticClass: "sty003" }, [
                                        _vm._v(_vm._s(item.dateCol)),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "imgDialog",
          attrs: { top: "5vh", visible: _vm.imgDialog, width: "320px" },
          on: {
            "update:visible": function ($event) {
              _vm.imgDialog = $event
            },
          },
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: {
              src: require("@/assets/banner/banner1-dialog.png"),
              alt: "",
            },
          }),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "luckDialog",
          attrs: {
            top: "25vh",
            visible: _vm.LuckyWheelShow,
            width: "480px",
            "show-close": _vm.showClose,
            "append-to-body": true,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.LuckyWheelShow = $event
            },
          },
        },
        [
          _c("LuckyWheel", {
            ref: "LuckyWheel",
            attrs: {
              width: "450px",
              height: "450px",
              blocks: _vm.blocks,
              prizes: _vm.prizes,
              buttons: _vm.buttons,
            },
            on: { start: _vm.startCallBack, end: _vm.endCallBack },
          }),
        ],
        1
      ),
      _vm.lucklyAnimateShow
        ? _c("LucklyAnimate", { on: { hideMe: _vm.hideMe } })
        : _vm._e(),
      _c("robot"),
      _c("right-float", { ref: "rightFloat", attrs: { globalRfType: true } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }